import React, { useEffect, useState } from 'react';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';

import Upload from '../Upload/Upload';
import ViewUploads from '../Upload/ViewUploads';

import {
  Box,
  Button,
  Grid,
  Typography,
  Divider,
  TextField,
  Modal,
} from '@mui/material';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';
import { SettingsInputComponent } from '@mui/icons-material';
import { border } from '@mui/system';

const BillingNoteUpliftment = (props) => {
  let ticketData = props.ticketData;
  let closeModel = props.closeModel;

  const readyToApprove = props.readyToApprove;
  const readyToInvoice = props.readyToInvoice;

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => setOpen3(false);

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [forceUpdate, setForceUpdate] = useState(1);

  const ticketID = ticketData['repair-ticket'].id;

  const [BillingData, setBillingData] = useState([]);

  const [WarehouseTransfer, setWarehouseTransfer] = useState('');

  const [t_WONumber, set_t_WONumber] = useState('');
  const [t_SONumber, set_t_SONumber] = useState('');
  const [t_GRNNumber, set_t_GRNNumber] = useState('');

  const [QuoteNumber, setQuoteNumber] = useState('');
  const [DeliveryNumber, setDeliveryNumber] = useState('');
  const [CourierUsed, setCourierUsed] = useState('');
  const [WaybillNumber, setWaybillNumber] = useState('');
  const [POP, setPOP] = useState('');
  const [PO, setPO] = useState('');
  const [POD, setPOD] = useState('');
  const [InvoiceNumber, setInvoiceNumber] = useState('');

  useEffect(() => {
    checkBillingInfo(ticketData).then((data) => setBillingData(data));
  }, [ticketData]);

  const checkBillingInfo = async (arr) => {
    // console.log(arr['billing-note'][0]);
    let data;
    if (arr['billing-note'][0].billing_checked === undefined) {
      data = {
        setWarehouseTransfer: '',
        setQuoteNumber: '',
        setDeliveryNumber: '',
        setCourierUsed: '',
        setWaybillNumber: '',
        setPOP: '',
        setPO: '',
        setPOD: '',
        setInvoiceNumber: '',
      };
    } else {
      data = await arr['billing-note'][0];
    }
    return data;
  };

  useEffect(() => {
    let data = BillingData;
    setWarehouseTransfer(data.WarehouseTransfer);
    setQuoteNumber(data.QuoteNumber);
    setDeliveryNumber(data.DeliveryNumber);
    setCourierUsed(data.CourierUsed);
    setWaybillNumber(data.WaybillNumber);
    setPOP(data.POP);
    setPO(data.PO);
    setPOD(data.POD);
    setInvoiceNumber(data.InvoiceNumber);
    set_t_WONumber(ticketData['repair-ticket'].wi_number);
    set_t_SONumber(ticketData.jobcard.order_number);
    set_t_GRNNumber(ticketData.jobcard.grn_number);
  }, [BillingData]);

  const handleChange = (event) => {
    switch (event.target.id) {
      case 'WarehouseTransfer':
        setWarehouseTransfer(event.target.value);
        break;
      case 'QuoteNumber':
        setQuoteNumber(event.target.value);
        break;
      case 'DeliveryNumber':
        setDeliveryNumber(event.target.value);
        break;
      case 'CourierUsed':
        setCourierUsed(event.target.value);
        break;
      case 'WaybillNumber':
        setWaybillNumber(event.target.value);
        break;
      case 'POP':
        setPOP(event.target.value);
        break;
      case 'PO':
        setPO(event.target.value);
        break;
      case 'POD':
        setPOD(event.target.value);
        break;
      case 'InvoiceNumber':
        setInvoiceNumber(event.target.value);
        break;
      case 'WONumber':
        set_t_WONumber(event.target.value);
        break;
      case 'SONumber':
        set_t_SONumber(event.target.value);
        break;
      case 'GRNNumber':
        set_t_GRNNumber(event.target.value);
        break;

      default:
        break;
    }
  };

  const combineData = () => {
    let ticketBlob = {
      'repair-ticket': {
        ticket_type: ticketData['repair-ticket'].ticket_type,
        customer_id: ticketData['repair-ticket'].customer_id,
        status: ticketData['repair-ticket'].status,
        wi_number: t_WONumber,
      },
      'billing-note': [
        {
          billing_checked: true,
          WarehouseTransfer: WarehouseTransfer,

          QuoteNumber: QuoteNumber,
          DeliveryNumber: DeliveryNumber,
          CourierUsed: CourierUsed,
          WaybillNumber: WaybillNumber,
          POP: POP,
          PO: PO,
          POD: POD,
          InvoiceNumber: InvoiceNumber,
        },
      ],
      jobcard: {
        order_number: t_SONumber,
        grn_number: t_GRNNumber,
      },
    };

    return ticketBlob;
  };

  const ticketUpdate = (ticketId) => {
    const DataBlob = { ...combineData() };
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = DataBlob;
    const request = new Request(`${APIROOT}/api/repair-tickets/${ticketId}`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save ticket`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          setForceUpdate((val) => val + 1);
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
          //CLOSE HERE
          closeModel();
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : `Connection Error !! ${error}`,
          'error'
        );
      });
  };

  return (
    <Box
      sx={{
        border: 'solid 2px #303030',
        borderRadius: '5px',
        padding: '10px',
        overflow: 'scroll',
      }}
    >
      <Grid container rowGap={1}>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>CUSTOMER:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={ticketTypoInfo}>
              {ticketData['repair-ticket'].customer_name}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>WAREHOUSE TRANSFER:</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              background:
                WarehouseTransfer === undefined ||
                WarehouseTransfer === '' ||
                WarehouseTransfer === null
                  ? '#00334433'
                  : 'none',
            }}
          >
            <Typography style={ticketTypoInfo}>
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={WarehouseTransfer}
                id='WarehouseTransfer'
                key='WarehouseTransfer'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}> WO NUMBER:</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              background:
                t_WONumber === undefined ||
                t_WONumber === '' ||
                t_WONumber === null
                  ? '#00334433'
                  : 'none',
            }}
          >
            <Typography style={ticketTypoInfo}>
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={t_WONumber}
                id='WONumber'
                key='WONumber'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>STORE ORDER NUMBER:</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              background:
                t_SONumber === undefined ||
                t_SONumber === '' ||
                t_SONumber === null
                  ? '#00334433'
                  : 'none',
            }}
          >
            <Typography style={ticketTypoInfo}>
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={t_SONumber}
                id='SONumber'
                key='SONumber'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>GRN NUMBER:</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              background:
                t_GRNNumber === undefined ||
                t_GRNNumber === '' ||
                t_GRNNumber === null
                  ? '#00334433'
                  : 'none',
            }}
          >
            <Typography style={ticketTypoInfo}>
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={t_GRNNumber}
                id='GRNNumber'
                key='GRNNumber'
                onChange={handleChange}
              />
              {/* {t_GRNNumber} */}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>QUOTE NUMBER:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  QuoteNumber === undefined ||
                  QuoteNumber === '' ||
                  QuoteNumber === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={QuoteNumber}
                id='QuoteNumber'
                key='QuoteNumber'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>
              DELIVERY NOTE NUMBER:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  DeliveryNumber === undefined ||
                  DeliveryNumber === '' ||
                  DeliveryNumber === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={DeliveryNumber}
                id='DeliveryNumber'
                key='DeliveryNumber'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>COURIER USED:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  CourierUsed === undefined ||
                  CourierUsed === '' ||
                  CourierUsed === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={CourierUsed}
                id='CourierUsed'
                key='CourierUsed'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>WAYBILL NUMBER:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  WaybillNumber === undefined ||
                  WaybillNumber === '' ||
                  WaybillNumber === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={WaybillNumber}
                id='WaybillNumber'
                key='WaybillNumber'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>POP:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  POP === undefined || POP === '' || POP === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={POP}
                id='POP'
                key='POP'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>PO:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  PO === undefined || PO === '' || PO === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={PO}
                id='PO'
                key='PO'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>POD:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  POD === undefined || POD === '' || POD === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={POD}
                id='POD'
                key='POD'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid item xs={6}>
            <Typography style={ticketTypoTitle}>INVOICE NUMBER:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              style={ticketTypoInfo}
              sx={{
                background:
                  InvoiceNumber === undefined ||
                  InvoiceNumber === '' ||
                  InvoiceNumber === null
                    ? '#00334433'
                    : 'none',
              }}
            >
              <TextField
                size='small'
                sx={{ width: '100%' }}
                value={InvoiceNumber}
                id='InvoiceNumber'
                key='InvoiceNumber'
                onChange={handleChange}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowGap={1}
          height='40px'
          sx={{ display: 'block', margin: '0 auto', marginBottom: '10px' }}
        >
          <Divider sx={{ marginBottom: '10px' }} />
          <Button
            variant='contained'
            style={{ float: 'right', marginLeft: '10px' }}
            onClick={() => readyToInvoice()}
          >
            Ready to invoice
          </Button>
          <Button
            variant='contained'
            style={{ float: 'right', marginLeft: '10px' }}
            onClick={() => readyToApprove()}
          >
            Ready to Approve
          </Button>
          <Button
            variant='contained'
            style={{ float: 'right', marginLeft: '10px' }}
            onClick={() => handleOpen3()}
          >
            View
          </Button>
          <Button
            variant='contained'
            style={{ float: 'right', marginLeft: '10px' }}
            onClick={() => handleOpen2()}
          >
            upload
          </Button>
          <Button
            variant='contained'
            style={{ float: 'right', marginLeft: '10px' }}
            onClick={() => ticketUpdate(ticketID)}
          >
            Save
          </Button>
        </Grid>
      </Grid>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={uploadModalStyle}>
          <Upload relationId={ticketID} relationType='repairTickets' />
        </Box>
      </Modal>
      <Modal
        open={open3}
        onClose={handleClose3}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={uploadModalStyle}>
          <ViewUploads relationId={ticketID} relationType='repairTickets' />
        </Box>
      </Modal>
    </Box>
  );
};

export default BillingNoteUpliftment;

const uploadModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: '80vh',
  overflow: 'scroll',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
